import React from 'react';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import './Textarea.css';

export interface WxbTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string | boolean;
  helpText?: string;
}

export const WxbTextarea = React.forwardRef<HTMLTextAreaElement, WxbTextareaProps>(
  ({
    label,
    error,
    helpText,
    className = '',
    disabled,
    id,
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': ariaInvalid,
    ...props
  }, ref) => {
    const isError = !!error;
    const { controlId, feedbackId } = useWxbFieldIds(id);
    const hasFeedback = typeof error === 'string' || (!error && Boolean(helpText));
    const describedBy = joinAriaIds(ariaDescribedBy, hasFeedback ? feedbackId : undefined);
    const cls = `wxb-textarea ${isError ? 'wxb-textarea-error' : ''} ${disabled ? 'wxb-textarea-disabled' : ''} ${className}`;
    return (
      <div className="wxb-field">
        {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
        <textarea
          ref={ref}
          id={controlId}
          className={cls}
          disabled={disabled}
          rows={4}
          aria-describedby={describedBy}
          aria-invalid={ariaInvalid ?? (isError || undefined)}
          {...props}
        />
        {typeof error === 'string' && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
        {!error && helpText && <span id={feedbackId} className="wxb-help">{helpText}</span>}
      </div>
    );
  }
);
WxbTextarea.displayName = 'WxbTextarea';
